import { render, staticRenderFns } from "./CoursewarePDFTableOfContent.vue?vue&type=template&id=f10c52f8&"
import script from "./CoursewarePDFTableOfContent.vue?vue&type=script&lang=js&"
export * from "./CoursewarePDFTableOfContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports